import React from "react"
import { resolveRichText } from "../../../utils/richText"
import WidgetWrapper from "../../internal/widgetWrapper/WidgetWrapper"
import * as styles from "./TextWidget.module.scss"

const TextWidget = ({ blok }) => {
  const text = resolveRichText(blok.text)
  return (
    <WidgetWrapper blok={blok}>
      <div className={styles.container}>
        <div dangerouslySetInnerHTML={text} className={blok.line_height ?? " "} />
      </div>
    </WidgetWrapper>
  )
}

export default TextWidget
